import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-edit-class-support-article',
    template: `
        <ng-container i18n="@@support.articles.editClass">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Find the class in the list or use the search field to find the class.</span>
                </li>
                <li>
                    <span>
                        Click on the three dots on the right side of the class.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editClassBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Edit</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <span>
                        Update the details as desired.<br />
                        To change the assigned instructors, open the dropdown selection and check or uncheck the preferred instructors.<br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editClass.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Save</strong> to save your changes.
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class EditClassSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
